import formatUnits from '#/utils/formatUnits';
import parseUnits from '#/utils/parseUnits';
import { BigNumberish, ethers } from 'ethers';

interface Props {
  value?: string | null;
  decimals?: BigNumberish;
  maxDecimalDigits?: number;
  suffix?: string | null;
  className?: string;
}

export default function EthereumFormatAPRString({
  value,
  decimals = 18,
  maxDecimalDigits = 2,
  suffix = '%',
  className,
}: Props) {
  return value != null ? (
    <span className={className}>
      {ethers.utils.commify(
        formatUnits(
          parseUnits(value, decimals).mul(100),
          decimals,
          maxDecimalDigits
        )
      )}
      {suffix}
    </span>
  ) : (
    <>-</>
  );
}
